import React, { createContext, useContext, useState } from 'react';

// Context for managing backroute information
const BackrouteContext = createContext();

// Provider component to wrap layouts
export const BackrouteProvider = ({ children }) => {
  const [backroute, setBackroute] = useState(null);
  const [title, setTitle] = useState(null);
  const [customBackHandler, setCustomBackHandler] = useState(null);
  const [backOnly, setBackOnly] = useState(false);

  const updateBackroute = ({
    path = null,
    title: newTitle = null,
    customHandler = null,
    backOnly: bo = false,
  }) => {
    setBackroute(path);
    setTitle(newTitle);
    setCustomBackHandler(() => customHandler);
    setBackOnly(bo);
  };

  const resetBackroute = () => {
    setBackroute(null);
    setTitle(null);
    setCustomBackHandler(null);
    setBackOnly(false);
  };

  return (
    <BackrouteContext.Provider
      value={{
        backroute,
        title,
        customBackHandler,
        backOnly,
        updateBackroute,
        resetBackroute,
      }}
    >
      {children}
    </BackrouteContext.Provider>
  );
};

// Hook for child components to set backroute information
export const useBackroute = () => {
  const context = useContext(BackrouteContext);
  if (!context) {
    throw new Error('useBackroute must be used within a BackrouteProvider');
  }
  return context;
};

// Hook for layouts to access backroute information
export const useBackrouteContext = () => {
  const context = useContext(BackrouteContext);
  return context || {};
};